export default defineNuxtRouteMiddleware(async () => {
	const isLogged = useCookie('is_logged')
	const facilityStore = useFacilityStore()

	if (!isLogged.value) {
		if (facilityStore.state.initialized) facilityStore.reset()
		return
	}

	if (facilityStore.state.initialized && facilityStore.getSelectedIdentifier) return
	if (facilityStore.isLoading) return

	try {
		await facilityStore.fetchFacilities()
		facilityStore.initFromStorage()
	} catch (error: any) {
		if (error.status === EHttpStatusCodes.HTTP_STATUS_FORBIDDEN) {
			const nuxtApp = useNuxtApp()
			nuxtApp.runWithContext(() => userStore.logout())
			return navigateTo('/login')
		}
	}
})
